import axios from '../../../commons/gdprcontrol-axios'

const state = {
  filterOptions: {
    categories: []
  },

  selectedOptions: {
    category: '',
    min_date: '',
    max_date: ''
  }
}

const getters = {
  getFilterOptions: state => state.filterOptions,
  getSelectedOptions: state => state.selectedOptions
}

const actions = {
  fetchFilterOptions: async ({ commit }) => {
    return axios.get('/api/events/szurok/')
      .then(response => {
        commit('setFilterOptions', response.data)
      })
      .catch(error => {
        alert('Hiba az esemény szűrők letöltése közben')
        throw error
      })
  }
}

const mutations = {
  setFilterOptions (state, filterOptions) {
    state.filterOptions = filterOptions
  },

  selectOption (state, { name, value }) {
    state.selectedOptions[name] = value
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/events/filterOptions.js